// extracted by mini-css-extract-plugin
module.exports = {"container":"page-intro-module--container--3Yc5V","less_spacing":"page-intro-module--less_spacing--1XVfY","smaller":"page-intro-module--smaller--21PG6"};